import { Link, useLocation } from "react-router-dom";

const MenuDesktopHorizontal = () => {
  const location = useLocation()

  return (
    <div className="hidden lg:flex bg-[#233238] w-full justify-end lg:sticky lg:top-0 left-0 lg:z-50 lg:justify-center lg:transform lg:h-20">
      <ul className="flex gap-1 w-full h-[68px] justify-end pt-10 pb-3 lg:pt-0 items-center max-w-2xl lg:max-w-4xl 2xl:max-w-6xl ecran-2000:max-w-7xl">
        <li className="flex">
          <Link to={"/"} className="relative flex">
            <span
              className={`tracking-tighter font-[yanone-regular] px-5 text-3xl lg-1120:text-4xl lg-1120:px-[35px] text-white duration-300 ease-out transition-colors hover:text-[#c3e88d]
              before:content-['<'] before:inline before:absolute before:text-white before:transform 
              hover:before:-translate-x-4 hover:before:opacity-100 before:ease-out before:duration-300  
              after:content-['/>'] after:inline after:absolute after:text-white after:transform after:-translate-x-4 after:opacity-0 
              hover:after:translate-x-1 hover:after:opacity-100 after:ease-out after:duration-300
              ${location.pathname === "/" ? "text-[#c3e88d] before:-translate-x-4 before:opacity-100 after:translate-x-1 after:opacity-100" : "text-white before:translate-x-0 before:opacity-0 after:-translate-x-4 after:opacity-0"}`}
            >
              Accueil
            </span>
          </Link>
        </li>
        <li className="flex">
          <Link to={"/projets"} className="relative flex">
            <span
              className={`tracking-tighter font-[yanone-regular] px-5 text-3xl lg-1120:text-4xl lg-1120:px-[35px] duration-300 ease-out transition-colors hover:text-[#82aac1]
              before:content-['<'] before:inline before:absolute before:text-white before:transform 
              hover:before:-translate-x-4 hover:before:opacity-100 before:ease-out before:duration-300  
              after:content-['/>'] after:inline after:absolute after:text-white after:transform after:-translate-x-4 after:opacity-0 
              hover:after:translate-x-1 hover:after:opacity-100 after:ease-out after:duration-300
              ${location.pathname === "/projets" ? "text-[#82aac1] before:-translate-x-4 before:opacity-100 after:translate-x-1 after:opacity-100" : "text-white before:translate-x-0 before:opacity-0 after:-translate-x-4 after:opacity-0"}`}
            >
              Projets
            </span>
          </Link>
        </li>
        
        <li className="flex">
          <Link to={"/animation"} className="relative flex">
            <span
              className={`tracking-tighter font-[yanone-regular] px-5 text-3xl lg-1120:text-4xl lg-1120:px-[35px] duration-300 ease-out transition-colors hover:text-[#ffcb6b]
              before:content-['<'] before:inline before:absolute before:text-white before:transform 
              hover:before:-translate-x-4 hover:before:opacity-100 before:ease-out before:duration-300  
              after:content-['/>'] after:inline after:absolute after:text-white after:transform after:-translate-x-4 after:opacity-0 
              hover:after:translate-x-1 hover:after:opacity-100 after:ease-out after:duration-300
              ${location.pathname === "/animation" ? "text-[#ffcb6b] before:-translate-x-4 before:opacity-100 after:translate-x-1 after:opacity-100" : "text-white before:translate-x-0 before:opacity-0 after:-translate-x-4 after:opacity-0"}`}
            >
              Animation
            </span>
          </Link>
        </li>

        <li className="flex">
          <Link to={"/contact"} className="relative flex">
            <span
              className={`tracking-tighter font-[yanone-regular] px-5 text-3xl lg-1120:text-4xl lg-1120:px-[35px] duration-300 ease-out transition-colors hover:text-[#f77669]
              before:content-['<'] before:inline before:absolute before:text-white before:transform 
              hover:before:-translate-x-4 hover:before:opacity-100 before:ease-out before:duration-300  
              after:content-['/>'] after:inline after:absolute after:text-white after:transform after:-translate-x-4 after:opacity-0 
              hover:after:translate-x-1 hover:after:opacity-100 after:ease-out after:duration-300
              ${location.pathname === "/contact" ? "text-[#f77669] before:-translate-x-4 before:opacity-100 after:translate-x-1 after:opacity-100" : "text-white before:translate-x-0 before:opacity-0 after:-translate-x-4 after:opacity-0"}`}
            >
              Contact
            </span>
          </Link>
        </li>

        <li className="flex">
          <Link to={"/livre-dor"} className="relative flex">
            <span
              className={`tracking-tighter font-[yanone-regular] px-5 text-3xl lg-1120:text-4xl lg-1120:px-[35px] duration-300 ease-out transition-colors hover:text-[#c792cf]
              before:content-['<'] before:inline before:absolute before:text-white before:transform 
              hover:before:-translate-x-4 hover:before:opacity-100 before:ease-out before:duration-300  
              after:content-['/>'] after:inline after:absolute after:text-white after:transform after:-translate-x-4 after:opacity-0 
              hover:after:translate-x-1 hover:after:opacity-100 after:ease-out after:duration-300
              ${location.pathname === "/livre-dor" ? "text-[#c792cf] before:-translate-x-4 before:opacity-100 after:translate-x-1 after:opacity-100" : "text-white before:translate-x-0 before:opacity-0 after:-translate-x-4 after:opacity-0"}`}
            >
              Livre d'Or
            </span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default MenuDesktopHorizontal;
